import { Component } from "react";

const RICARICABILE = /Loading (chunk|CSS chunk)|ChunkLoadError|dynamically imported module|Importing a module script failed|Failed to fetch/i;

/** Evita la schermata bianca: mostra il dettaglio dell'errore, permette di ricaricare
 *  svuotando la cache e ricarica da solo se i file dell'app non sono più disponibili
 *  dopo una nuova pubblicazione. */
export class ErrorBoundary extends Component {
  state = { errore: null, dettaglio: "" };

  static getDerivedStateFromError(errore) {
    return { errore, dettaglio: `${errore?.name || "Errore"}: ${errore?.message || ""}` };
  }

  componentDidCatch(errore) {
    const testo = `${errore?.name || ""} ${errore?.message || ""}`;
    const ultimo = Number(sessionStorage.getItem("bc_reload") || 0);
    if (RICARICABILE.test(testo) && Date.now() - ultimo > 60000) {
      sessionStorage.setItem("bc_reload", String(Date.now()));
      this.ricarica();
    }
  }

  ricarica = () => {
    const u = new URL(window.location.href);
    u.searchParams.set("v", String(Date.now()));
    window.location.replace(u.toString());
  };

  copia = () => {
    const testo = `${window.location.pathname} — ${this.state.dettaglio}`;
    if (navigator.clipboard) navigator.clipboard.writeText(testo);
  };

  render() {
    if (!this.state.errore) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-4" data-testid="error-boundary">
        <div className="max-w-md w-full rounded-sm border border-border bg-card p-4 space-y-3">
          <h1 className="font-head text-lg font-bold">Pagina non caricata</h1>
          <p className="text-sm text-muted-foreground">
            Si è verificato un errore nell'apertura di questa pagina. Ricarica: se hai appena
            ricevuto un aggiornamento, il ricaricamento risolve.
          </p>
          <pre className="text-[11px] leading-snug bg-muted/60 border border-border rounded-sm p-2 whitespace-pre-wrap break-words"
            data-testid="error-detail">{this.state.dettaglio}</pre>
          <div className="flex flex-wrap gap-2">
            <button type="button" data-testid="error-retry"
              className="h-9 px-4 rounded-sm bg-primary text-primary-foreground text-sm font-semibold"
              onClick={this.ricarica}>Ricarica la pagina</button>
            <button type="button" data-testid="error-home"
              className="h-9 px-4 rounded-sm border border-border text-sm font-semibold"
              onClick={() => { window.location.href = "/"; }}>Torna al menu</button>
            <button type="button" data-testid="error-copy"
              className="h-9 px-4 rounded-sm border border-border text-sm font-semibold"
              onClick={this.copia}>Copia dettagli</button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
